import qs from 'querystringify'
import remote from './remote'

const URL = {
   SEARCH: '/cms/contents',
   DELETE: '/cms/contents'
}

export default {
    searchContent (option) {
        let url = remote.getUrl(URL.SEARCH)

        if (option) {
            url = url + '?' + qs.stringify(option)
        }

        return remote.request({
            url: url,
        })
    },
    removeContent (contentId) {
        return remote.request({
            url: remote.getUrl(URL.DELETE),
            method: remote.METHOD.DELETE,
            headers: {
                'Content-Type': 'application/json'
            },
            data: Array.isArray(contentId) ? contentId : [contentId],
        })
    }
}
